import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Spin } from 'antd';
import { fetchProviderByName } from 'api/providers-api';
import { txt } from 'libs/i18n';
import { useEffect, useState } from 'react';
import { useSession } from 'components/Authenticated';
import ApiToken from '../ApiToken';
import style from './style.module.less';
const ProviderAccountTab = () => {
    const [linkUrl, setLinkUrl] = useState(null);
    const { session } = useSession();
    const updateLink = async () => {
        var _a;
        try {
            const providerKey = (_a = session.login.claims.find((c) => c.startsWith('ExternalLoginProvider:'))) === null || _a === void 0 ? void 0 : _a.split(':')[1];
            if (providerKey === undefined) {
                global.logger.error('No provider information available');
                return;
            }
            const providerConfig = await fetchProviderByName(session.connection, providerKey);
            setLinkUrl(providerConfig.accountUrl);
        }
        catch (err) {
            global.logger.error('Failed to load provider configuration');
        }
    };
    useEffect(() => {
        void updateLink();
    }, []);
    return (_jsxs("div", { className: style.providerAccountTab, children: [linkUrl === null ? _jsx(Spin, {}) : _jsx("a", { href: linkUrl, target: "_blank", rel: "noreferrer", children: txt('manageAccount') }), _jsx(ApiToken, {})] }));
};
export default ProviderAccountTab;
